function SemiFinalsLines() {
  return (
    <div className="lines-container">
      <div className="line-container">
        <div className="arrow"></div>
        <div className="box" style={{ width: "1000px" }}></div>
      </div>
    </div>
  );
}

export default SemiFinalsLines;
